

























































































































import {Emit} from "vue-property-decorator";
import {Stored} from "vue-stored-prop-decorator";
import {Component} from '@/shared/component';
import {AbstractShowVue} from '@/components/Abstract/AbstractShowVue';
import {Client, Tache, Token, Projet} from '@/models';

import storeClient from '@/stores/modules/client';
import storeToken from "@/stores/modules/token";

import CrudClientEditDialog from '@/components/Crud/Client/EditDialog.vue';
import CrudClientEditPdfDialog from '@/components/Crud/Client/EditPdfDialog.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';
import CrudProjetListClient from "@/components/Crud/Projet/ListClient.vue";
import CrudProjetEditDialog from "@/components/Crud/Projet/EditDialog.vue";

@Component({
	components: {
		CrudClientEditDialog,
		CrudClientEditPdfDialog,
		CrudDeleteDialog,
		CrudProjetListClient,
		CrudProjetEditDialog,
	}
})
export default class CrudClientShow extends AbstractShowVue<Client> {

	private imgPath: string = "";

	private editPdf: number = null;
	private editClient: Client = null;
	private editProjet: Projet = null;
	private list;

	@Stored(() => storeToken)
	private token: Token;

	@Emit()
	private onCreate(): void {
		this.editPdf = this.value.id;
	}

	@Emit()
	private onCreateProjet(): void {
		let projet = new Projet()
		projet.client = this.value
		this.editProjet = projet;
	}

	public constructor() {
		super(storeClient);
	}

	public async mounted(): Promise<void> {
		this.list = this.$refs['list'] as CrudProjetListClient
		await super.mounted();
	}

	public async refresh(value: any): Promise<void> {
		await super.refresh(value);

		if (this.item !== null)
		{
			this.imgPath = "/img/files/proprietaire.jpg";

			if (this.$route.name === 'client-show') {
				this.$route.meta.title = 'Détails  d\'un client';
			}
		}

	}


}
